import React, { FC } from 'react';
import { Button } from 'antd';

export interface MiniPaginatorProps {
  page: number;
  pages: number;
  hasPrev: boolean;
  hasNext: boolean;
  onChange: (page: number) => void;
  className?: string;
}

export const MiniPaginator: FC<MiniPaginatorProps> = ({
  page,
  pages,
  hasPrev,
  hasNext,
  onChange,
  className,
}) => {
  const handlePrev = () => {
    if (hasPrev) onChange(page - 1);
  };

  const handleNext = () => {
    if (hasNext) onChange(page + 1);
  };

  return (
    <div className={`mini-pagination ${className || ''}`.trim()}>
      <Button className="mini-page-btn" disabled={!hasPrev} onClick={handlePrev} size="small">
        <i className="fas fa-chevron-left"></i>
      </Button>

      <span className="mini-page-info">{page} / {pages}</span>

      <Button className="mini-page-btn" disabled={!hasNext} onClick={handleNext} size="small">
        <i className="fas fa-chevron-right"></i>
      </Button>
    </div>
  );
};

export default MiniPaginator;


